import styled from "styled-components"

const NavigationText = styled.div`
  color: ${props => (props.active ? "#fff" : "rgba(255,255,255,0.5)")};
  font-family: "din-condensed";
  font-weight: 400;
  font-size: 22px;
  margin-left: 1rem;
  margin-right: auto;
  text-transform: uppercase;
  max-width: 162px;
`

export default NavigationText



// WEBPACK FOOTER //
// ./src/Kiosk/Navigator/NavigationText.js